module.exports = __webpack_public_path__ + "static/img/aWINDOW.cb576b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aWINDOW.png
// module id = Wo+s
// module chunks = 1